type TFormikValidationError = {
  path: string;
  message: string;
};

type TFormikValidationErrors = {
  inner: TFormikValidationError[];
};

type TTransformedValidationErrors = {
  [path: string]: string;
};

const transformValidationErrors =
  (validationErrors: TFormikValidationErrors): TTransformedValidationErrors => {
  // Transform the `errors` object returned by validationSchema.validate from
  // formik into a much simpler object with key: value pairs of the form
  // fieldName: errorText. This object can then be passed to formik's setErrors
  // action post-validate to easily show errors on the form

    return validationErrors.inner
      .reduce((accumulator: { [path: string]: string }, error: TFormikValidationError) => {
        /* eslint-disable-next-line */
        accumulator[error.path] = error.message;
        return accumulator;
      }, {});
  };

const validate = (values: any, validationSchema: any) => {
  return new Promise((resolve, reject) => {
    validationSchema
      .validate(values, {
        strict: true,
        abortEarly: false,
      })
      .then((validatedPayload: any) => resolve(validatedPayload))
      .catch((validationErrors: any) => reject(transformValidationErrors(validationErrors)));
  });
};

export {
  validate,
  transformValidationErrors,
};
